export default __webpack_public_path__ + "static/media/bannerMobile.e014ec76.png";